import {view} from '@sail/ui';
import {createKeyframes} from '@sail/engine';
import type {MessagePartComponentProps} from '../MessagePartComponentContext';
import {MarkdownText} from '../../StripeAssistant/LiveAnswersV2/MarkdownText';

const blink = createKeyframes({
  0: {opacity: 1},
  50: {opacity: 0},
  100: {opacity: 1},
});

export function AiResponsePartComponent({
  message,
  part,
}: MessagePartComponentProps) {
  const isStreaming = part.dynamic === 'if_latest' || part.dynamic === 'active';
  const {text} = part.content;

  if (!text && isStreaming) {
    return (
      <view.div
        data-testid="ai-response-loading"
        css={{
          paddingY: 'small',
        }}
      >
        <BlinkingCursor />
      </view.div>
    );
  }

  if (!text) {
    return null;
  }

  return (
    <view.div
      data-testid="ai-response-part"
      data-message-id={message.id}
      css={{stack: 'y', gap: 'xsmall'}}
    >
      <MarkdownText body={text} />
      {isStreaming ? <BlinkingCursor /> : null}
    </view.div>
  );
}

function BlinkingCursor() {
  return (
    <view.span
      data-testid="ai-response-cursor"
      css={{
        display: 'inline-block',
        width: '2px',
        height: '1em',
        backgroundColor: 'currentColor',
        animation: `${blink} 1s step-end infinite`,
      }}
      aria-hidden="true"
    />
  );
}
